export const siteConfig = {
  brand: '姐姐的朋友',
  brandEn: 'JIEJIE DE PENGYOU',
  tagline: '电影电视剧剧情介绍与资讯平台',
  description:
    '姐姐的朋友影视内容站提供最新电影和电视剧剧情介绍、影评资讯及演员资料，让您全面了解《姐姐的朋友》相关影视作品。',
  nav: [
    { label: '首页', to: '/' },
    { label: '影视分类', to: '/category' },
    { label: '资讯专题', to: '/topic/topic-1' },
    { label: '演员资料', to: '/actor/actor-1' },
    { label: '关于我们', to: '/about' },
  ],
  friendLinks: [
    { label: '影视资讯首页', to: '/' },
    { label: '电影分类', to: '/category?type=movie' },
    { label: '电视剧分类', to: '/category?type=series' },
    { label: '姐姐的朋友专题', to: '/topic/topic-1' },
    { label: '演员资料库', to: '/actor/actor-1' },
    { label: '关于我们', to: '/about' },
  ],
};

export const heroSlides = [
  {
    id: 'hero-1',
    filmId: 'film-1',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20young%20woman%20looking%20out%20from%20a%20rain%20streaked%20window%20overlooking%20a%20city%20at%20night%2C%20deep%20navy%20sky%20and%20warm%20amber%20street%20lights%2C%20soft%20bokeh%2C%20moody%20romantic%20atmosphere%2C%20widescreen%20composition%2C%20subtle%20film%20grain%2C%20cinematic%20color%20grading&width=1920&height=900&seq=hero-jjdp&orientation=landscape',
    kicker: '编辑推荐 · 年度必看',
    title: '《姐姐的朋友》',
    description: '有些喜欢，注定只适合藏在心里。一场关于暗恋与成全的都市故事。',
  },
  {
    id: 'hero-2',
    filmId: 'film-2',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20reunion%20at%20an%20airport%20terminal%20with%20warm%20golden%20hour%20light%20streaming%20through%20windows%2C%20soft%20haze%2C%20widescreen%20composition%2C%20moody%20romantic%20atmosphere%2C%20subtle%20film%20grain%2C%20cinematic%20color%20grading&width=1920&height=900&seq=hero-cfdp&orientation=landscape',
    kicker: '热播剧集 · 全网热议',
    title: '《姐姐的朋友·重逢》',
    description: '五年后再度相遇，他们都不再是当年小心翼翼的自己。',
  },
  {
    id: 'hero-3',
    filmId: 'film-8',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20space%20scene%20of%20a%20spaceship%20drifting%20near%20a%20warm%20glowing%20planet%2C%20deep%20navy%20starfield%20with%20amber%20nebula%20light%2C%20epic%20widescreen%20composition%2C%20cinematic%20color%20grading%2C%20subtle%20film%20grain&width=1920&height=900&seq=hero-xingchen&orientation=landscape',
    kicker: '新片上线 · 科幻爱情',
    title: '《星尘之约》',
    description: '跨越光年，只为赴一场约定。',
  },
];

export const searchSuggestions = ['姐姐的朋友', '剧情', '悬疑剧集', '林知夏', '科幻爱情', '年度盘点'];